module.exports = __webpack_public_path__ + "img/mind_skeleton_13.d55f3e83.png";